import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaLinkedinIn, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { handlePhoneCall } from '../utils/phoneHandler';

const Footer = () => {
  
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo and Social */}
          <div>
            <div className="flex items-center mb-6">
              <div className="bg-yellow-500 text-black w-10 h-10 rounded flex items-center justify-center mr-3">
                <span className="font-bold text-xl">M</span>
              </div>
              <h3 className="text-2xl font-bold">MaxiCar</h3>
            </div>
            <p className="text-gray-400 text-sm mb-6">
              Best Premium Taxi service. Experience the future of transportation in Worms and beyond.
            </p>
            <div className="flex space-x-3">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="bg-gray-800 hover:bg-yellow-500 hover:text-black text-gray-300 w-8 h-8 rounded-full flex items-center justify-center transition-colors">
                <FaFacebookF size={14} />
              </a>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="bg-gray-800 hover:bg-yellow-500 hover:text-black text-gray-300 w-8 h-8 rounded-full flex items-center justify-center transition-colors">
                <FaTwitter size={14} />
              </a>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="bg-gray-800 hover:bg-yellow-500 hover:text-black text-gray-300 w-8 h-8 rounded-full flex items-center justify-center transition-colors">
                <FaInstagram size={16} />
              </a>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="bg-gray-800 hover:bg-yellow-500 hover:text-black text-gray-300 w-8 h-8 rounded-full flex items-center justify-center transition-colors">
                <FaYoutube size={16} />
              </a>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="bg-gray-800 hover:bg-yellow-500 hover:text-black text-gray-300 w-8 h-8 rounded-full flex items-center justify-center transition-colors">
                <FaLinkedinIn size={14} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">Services</Link></li>
              <li><Link to="/fleet" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">Our Fleet</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">Pricing</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-yellow-500 mt-1 mr-3 flex-shrink-0" />
                <span className="text-gray-400 text-sm">Bahnhofstraße 30, 67547 Worms</span>
              </li>
              <li className="flex items-center">
                <FaPhoneAlt className="text-yellow-500 mr-3 flex-shrink-0" />
                <a href="tel:+4962414700" 
                   className="text-gray-400 hover:text-yellow-500 text-sm transition-colors"
                   onClick={(e) => handlePhoneCall('+49 6241 4700', e, 'footer')}
                   >+49 6241 4700</a>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="text-yellow-500 mr-3 flex-shrink-0" />
                <a href="mailto:info@taxiworms.de" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">info@ maxicarworms.de  </a>
              </li>
              <li className="flex items-center">
                <FaClock className="text-yellow-500 mr-3 flex-shrink-0" />
                <span className="text-gray-400 text-sm">24/7 Available</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Newsletter</h4>
            <p className="text-gray-400 text-sm mb-4">Subscribe to our newsletter for updates & offers</p>
            <div className="flex">
              <input 
                type="email" 
                placeholder="Your email address" 
                className="px-4 py-2 text-sm text-gray-900 bg-white rounded-l focus:outline-none focus:ring-1 focus:ring-yellow-500 w-full"
              />
              <button className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-2 rounded-r text-sm font-medium transition-colors">
                Subscribe
              </button>
            </div>
            <div className="mt-4 flex items-start">
              <input 
                type="checkbox" 
                id="privacy" 
                className="mt-1 rounded border-gray-400 text-yellow-500 focus:ring-yellow-500" 
              />
              <label htmlFor="privacy" className="ml-2 text-gray-400 text-xs">
                I agree to the{' '}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" className="text-yellow-500 hover:underline">Privacy Policy</a>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Methods */}
      <div className="bg-gray-800 py-6 border-t border-gray-700">
        <div className="container mx-auto px-4">
          <p className="text-gray-400 text-sm mb-4 text-center">We accept all major payment methods:</p>
          <div className="flex flex-wrap justify-center gap-4">
            {/* Visa */}
            <div className="bg-white p-2 rounded-md shadow-sm flex items-center justify-center w-16 h-10">
              <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="40">
                <rect width="38" height="24" rx="3" fill="#1a1f71"/>
                <text x="19" y="15" textAnchor="middle" fill="#fff" fontSize="8" fontFamily="Arial, sans-serif" fontWeight="bold">VISA</text>
              </svg>
            </div>

            {/* Mastercard */}
            <div className="bg-white p-2 rounded-md shadow-sm flex items-center justify-center w-16 h-10">
              <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="40">
                <rect width="38" height="24" rx="3" fill="#000"/>
                <circle cx="14" cy="12" r="6" fill="#eb001b"/>
                <circle cx="24" cy="12" r="6" fill="#f79e1b"/>
                <path d="M19 7.5c1.1 1.3 1.8 3 1.8 4.5s-.7 3.2-1.8 4.5c-1.1-1.3-1.8-3-1.8-4.5s.7-3.2 1.8-4.5z" fill="#ff5f00"/>
              </svg>
            </div>

            {/* American Express */}
            <div className="bg-white p-2 rounded-md shadow-sm flex items-center justify-center w-16 h-10">
              <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="40">
                <rect width="38" height="24" rx="3" fill="#016fd0"/>
                <text x="19" y="15" textAnchor="middle" fill="#fff" fontSize="6" fontFamily="Arial, sans-serif" fontWeight="bold">AMEX</text>
              </svg>
            </div>

            {/* PayPal */}
            <div className="bg-white p-2 rounded-md shadow-sm flex items-center justify-center w-16 h-10">
              <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="40">
                <rect width="38" height="24" rx="3" fill="#002c8a"/>
                <path d="M8 8h6c2 0 3.5 1.5 3.5 3.5S16 15 14 15h-2l-.5 3H9l1.5-10z" fill="#009cde"/>
                <path d="M12 10h6c2 0 3.5 1.5 3.5 3.5S20 17 18 17h-2l-.5 3H13l1.5-10z" fill="#012169"/>
                <text x="19" y="20" textAnchor="middle" fill="#fff" fontSize="4" fontFamily="Arial, sans-serif">PayPal</text>
              </svg>
            </div>

            {/* Apple Pay */}
            <div className="bg-black p-2 rounded-md shadow-sm flex items-center justify-center w-16 h-10">
              <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="40">
                <rect width="38" height="24" rx="3" fill="#000"/>
                <path d="M12 8c-.5-1.5.5-3 2-3 .2 1.5-.5 3-2 3zm2.5 1c1.5 0 2.5 1 2.5 2.5v3c0 .5-.5 1-1 1s-1-.5-1-1v-3c0-.5-.5-1-1-1s-1 .5-1 1v3c0 .5-.5 1-1 1s-1-.5-1-1v-5c0-.5.5-1 1-1h1.5z" fill="#fff"/>
                <text x="26" y="15" fill="#fff" fontSize="6" fontFamily="Arial, sans-serif">Pay</text>
              </svg>
            </div>

            {/* Google Pay */}
            <div className="bg-white p-2 rounded-md shadow-sm flex items-center justify-center w-16 h-10">
              <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="40">
                <rect width="38" height="24" rx="3" fill="#fff" stroke="#e0e0e0"/>
                <path d="M8 10h4v1h-4v-1zm0 2h4v1h-4v-1z" fill="#4285f4"/>
                <path d="M14 10h4v1h-4v-1zm0 2h4v1h-4v-1z" fill="#34a853"/>
                <path d="M20 10h4v1h-4v-1zm0 2h4v1h-4v-1z" fill="#fbbc05"/>
                <path d="M26 10h4v1h-4v-1zm0 2h4v1h-4v-1z" fill="#ea4335"/>
                <text x="19" y="18" textAnchor="middle" fill="#5f6368" fontSize="4" fontFamily="Arial, sans-serif">Google Pay</text>
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="bg-gray-800 py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-2 md:mb-0">
              &copy; {new Date().getFullYear()} MaxiCar. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">
                Terms & Conditions
              </Link>
              <Link to="/cookies" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">
                Cookies Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;